import {
  menusResponseSchema, type MenusResponse, type MenuType, type MenuStatus 
} from '../types';
import {
  ApiClientError, buildUrl 
} from '@/errors';
import {
  authFetch, API_BASE_URL 
} from '@/lib/api-client';

export interface MenuFilters {
  readonly venueId?: string;
  readonly type?: MenuType;
  readonly status?: MenuStatus;
}

export async function getMenus(siteId: string, filters?: MenuFilters): Promise<MenusResponse> {
  const params = new URLSearchParams();
  if (filters?.venueId) params.set('venueId', filters.venueId);
  if (filters?.type) params.set('type', filters.type);
  if (filters?.status) params.set('status', filters.status);

  const url = buildUrl(API_BASE_URL, `/v1/sites/${siteId}/menus`, params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch menus');
  }

  return menusResponseSchema.parse(await response.json());
}
